import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "highlight" }
const _hoisted_3 = /*#__PURE__*/_createVNode("button", {
  class: "highlight-copy btn",
  "data-bs-toggle": "tooltip",
  title: "Copy code"
}, " copy ", -1)
const _hoisted_4 = {
  class: "nav nav-pills",
  role: "tablist"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = { class: "highlight-code" }
const _hoisted_9 = { class: "language-html" }
const _hoisted_10 = { class: "language-html" }
const _hoisted_11 = { class: "highlight-code" }
const _hoisted_12 = { class: "language-js" }
const _hoisted_13 = { class: "language-js" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("ul", _hoisted_4, [
        _createVNode("li", _hoisted_5, [
          _createVNode("a", {
            class: "nav-link active",
            "data-bs-toggle": "tab",
            href: `#kt_highlight_${_ctx.htmlId}`,
            role: "tab",
            "aria-selected": "true"
          }, "HTML", 8, ["href"])
        ]),
        _createVNode("li", _hoisted_6, [
          _createVNode("a", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            href: `#kt_highlight_${_ctx.jsId}`,
            role: "tab",
            "aria-selected": "false"
          }, "JAVASCRIPT", 8, ["href"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", {
          class: "tab-pane fade active show",
          id: `kt_highlight_${_ctx.htmlId}`,
          role: "tabpanel"
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("pre", _hoisted_9, [
              _createVNode("code", _hoisted_10, [
                _renderSlot(_ctx.$slots, "html")
              ])
            ])
          ])
        ], 8, ["id"]),
        _createVNode("div", {
          class: "tab-pane fade",
          id: `kt_highlight_${_ctx.jsId}`,
          role: "tabpanel"
        }, [
          _createVNode("div", _hoisted_11, [
            _createVNode("pre", _hoisted_12, [
              _createVNode("code", _hoisted_13, [
                _renderSlot(_ctx.$slots, "js")
              ])
            ])
          ])
        ], 8, ["id"])
      ])
    ])
  ]))
}